import FilterListIcon from '@mui/icons-material/FilterList';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Theme } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ChannelType } from '../../../../sic-lib/enums/ChannelType';
import { setConversationChannels } from '../../../../store/conversation';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';

const useStyles = makeStyles()((theme: Theme) => ({
    btnChannel: {
        color: theme.palette.btnDefault.main,
        '&:hover': {
            backgroundColor: theme.palette.btnDefault.light,
        },
    },
}));

export default function MenuChannelOptions() {
    const dispatch = useAppDispatch();
    const { classes } = useStyles();
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const channels = useAppSelector(state => {
        return state.conversation?.channels || [];
    });

    const handleFilterChange = (value: ChannelType) => {
        dispatch(setConversationChannels({ filters: value }));
    };

    return (
        <React.Fragment>
            <Button
                className={classes.btnChannel}
                endIcon={<FilterListIcon />}
                aria-haspopup="true"
                onClick={e => setAnchorEl(e.currentTarget)}
            >
                Channels
            </Button>
            <Menu
                id="channels_menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                {channels.map(flt => {
                    return (
                        <MenuItem key={flt.value}>
                            <FormControlLabel
                                label={flt.label}
                                control={
                                    <Switch
                                        size="medium"
                                        checked={flt.isActive}
                                        onChange={() => handleFilterChange(flt.value)}
                                    />
                                }
                            />
                        </MenuItem>
                    );
                })}
            </Menu>
        </React.Fragment>
    );
}
